export const plural = (count: number, one: string, many: string): string =>
  count === 1 ? one : many

export const transactionNoun = (count: number): string =>
  plural(count, 'transaction', 'transactions')
